import React from 'react';
import PropTypes from 'prop-types';
import { List } from 'immutable';
import isEmpty from 'lodash/isEmpty';
import cx from 'classnames';

import { AddOns } from 'models/addons';
import { Location } from 'models/locations';

import AddOn from 'components/checkout/add-ons/add-on';

const propTypes = {
  addOnType: PropTypes.string.isRequired,
  location: PropTypes.instanceOf(Location).isRequired,
  addOns: PropTypes.instanceOf(List),
  selectedAddOns: PropTypes.instanceOf(AddOns),
  required: PropTypes.bool,
  handleSelectedAddOn: PropTypes.func.isRequired,
};

const defaultProps = {
  addOns: List(),
  selectedAddOns: new AddOns(),
  required: false,
  intl: {},
};

const AddOnCategory = ({
  addOns,
  addOnType,
  required,
  location,
  selectedAddOns,
  handleSelectedAddOn,
}) => {
  const displayName = AddOns.getDisplayName(addOnType);

  const addOnClass = cx({
    'checkout-section': true,
    'clearfix': true,
    'required': required,
    'optional': !required,
    'border-color-grey': true,
    'border-side-top': true,
    'padding-top-30': true,
    'padding-bottom-40': true,
  });


  if (!addOns || !addOns.size) { return <div key={addOnType} />; }

  return (
    <div className={addOnClass} key={addOnType}>
      <h2 className="display-sm-inline-block display-xs-block margin-bottom-sm-15 margin-top-xs-0 margin-top-xs-5 margin-bottom-xs-15 text-color-dark-slate text-size-20 text-weight-bold">
        { isEmpty(displayName) ? addOnType : displayName }
      </h2>
      { required ? <div className="header-notes text-weight-book">*Required</div> : null }
      {addOns.map(addOn => (
        <AddOn
          addOn={addOn}
          addOnType={addOnType}
          key={`ao-${addOn.name.toLowerCase()}`}
          location={location}
          onSelect={handleSelectedAddOn}
          required={required}
          selected={(selectedAddOns[addOnType] || List()).includes(addOn)}
        />
      ))}
      <hr className="visible-xs" />
    </div>
  );
};

AddOnCategory.propTypes = propTypes;
AddOnCategory.defaultProps = defaultProps;
export default AddOnCategory;
